export const settingsService = {
  add,
  update,
  remove,
};

/**
 *
 * @param {*} setting
 * @returns
 */
function add(setting) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(setting),
  };

  return fetch(
    process.env.REACT_APP_API_URL + "/v1/settings",
    requestOptions
  ).then(handleResponse);
}

/**
 *
 * @param {*} setting
 * @returns
 */
function update(setting) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(setting),
  };

  return fetch(
    process.env.REACT_APP_API_URL + "/v1/settings",
    requestOptions
  ).then(handleResponse);
}

/**
 *
 * @param {*} setting
 * @returns
 */
function remove(id) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  };

  return fetch(
    process.env.REACT_APP_API_URL + `/v1/settings/${id}`,
    requestOptions
  ).then(handleResponse);
}

/**
 *
 * @param {*} response
 * @returns
 */

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text;
    if (!response.ok) {
      if (response.status === 401) {
        const error = "Connexion impossible. Vérifier vos identifiants ";
        return Promise.reject(error);
      }

      const error =
        (data &&
          JSON.parse(data).message &&
          JSON.parse(data).message.split("nom: ")[1]) ||
        (data && JSON.parse(data).message) ||
        response.statusText;
      return Promise.reject(error);
    }
    return JSON.parse(data);
  });
}
